// Direct DOM head-tag management for the public landing page. We avoid
// react-helmet to keep the customer-portal bundle small — there are only a
// handful of tags to set and they're all upserts.

function upsertMeta(attr, key, value) {
  if (typeof document === 'undefined' || !value) return;
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', String(value));
}

function upsertLink(rel, href) {
  if (typeof document === 'undefined' || !href) return;
  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', String(href));
}

/**
 * Set document.title + meta description + og:* + canonical. Called once
 * per page load after the page payload arrives. Safe to call repeatedly —
 * tags are upserted, not duplicated.
 *
 * @param {object} page  Backend LandingPageDto: name, slug, seoTitle, etc.
 */
export function applyLandingPageMeta(page) {
  if (!page) return;
  const title = (page.seoTitle && page.seoTitle.trim()) || page.name || 'Landing page';
  const description = (page.seoDescription && page.seoDescription.trim()) || '';
  const image = (page.seoImageUrl && page.seoImageUrl.trim()) || '';

  if (typeof document !== 'undefined') {
    document.title = title;
  }

  upsertMeta('name', 'description', description);

  upsertMeta('property', 'og:title', title);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:type', 'website');
  if (image) upsertMeta('property', 'og:image', image);

  upsertMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
  upsertMeta('name', 'twitter:title', title);
  upsertMeta('name', 'twitter:description', description);
  if (image) upsertMeta('name', 'twitter:image', image);

  if (typeof window !== 'undefined' && window.location) {
    upsertLink('canonical', window.location.href.split('#')[0]);
    upsertMeta('property', 'og:url', window.location.href.split('#')[0]);
  }
}
